angular.module("ngModal", [])
/**
 * ngModal 元件，主要處理 Modal 開啟關閉功能，注意：一定要給予 modal 一個獨立的 id
 *
 * #### 關閉 Modal 的方法
 *
 * 方法一 ： 使用 close-modal 屬性
 * <div ng-modal>
 * 		<div class="button" close-modal></div>
 * </div>
 *
 * 方法二： 自定義 ng-click 並呼叫 $scope.closeModal();
 *
 * 快捷鍵 : esc 可以快速關掉modal，使用 MouseTrap plugin(http://craig.is/killing/mice)
 *
 * @return {[type]}
 */
.directive("ngModal", [ '$rootScope', '$timeout', '$ngModal', '$ngDropdown',
	function ($rootScope, $timeout, $ngModal, $ngDropdown) {
	return {
		restrict: "AE",
		scope: true,
		link: function (scope, elem, attrs) {

			var modalName = attrs.ngModal;
			if(!modalName){
				return;
			}

			scope.isOpen = false;

			// 接收 Modal 開啟事件
			scope.$on("OPEN_MODAL_" + modalName, function () {
				scope.openModal();
			});

			// 接收 Modal 關閉事件
			scope.$on("CLOSE_MODAL_" + modalName, function () {
				scope.closeModal();
			});

			// close-modal 屬性點擊事件處理
			elem.find("[close-modal]").on("click", function (event) {
				scope.$apply(function () {
					scope.closeModal();
				});
			});

			elem.find('.md-content').on("click", function (event) {
				// 點擊content時關閉所有dropdown ( 有點暴力的做法 可能需要修正 by @Gray
				$ngDropdown.hideAllDropdown();

				event.stopPropagation();
			});

			// 關閉 modal 處理
			scope.openModal = function () {
				scope.isOpen = true;
				var list = $ngModal.getOpenList();
				if(list.length == 0){
					// lockWindowScroll();
				}

				$ngModal.addShownModal(modalName);
				$rootScope.$broadcast("OPEN_MODAL_COMPLETE", modalName);
				$(document).on('keydown.modal' + modalName, function(event) {
					if(event.keyCode == 27) {
						var last = $ngModal.getLastOpenModal();
						if(last && last == modalName){
							scope.closeModal();
						}
					}
				});
			};

			// 關閉 modal 處理
			scope.closeModal = function () {
				scope.isOpen = false;
				$timeout(function(){
					$ngModal.removeShownModal(modalName);
					var list = $ngModal.getOpenList();
					if(list.length == 0){
						// unlockWindowScroll();
					}
					$(document).off('keydown.modal' + modalName);
					$rootScope.$broadcast("CLOSE_MODAL_COMPLETE", modalName);
				});
			};
		}
	}
}])

/**
 * 開啟 ngModal 的 Directive
 * 範例 :
 * 		<div class="button" open-modal="modal-1">Close</div>
 *
 * 		或是使用 $ngModal.openModal() 方法
 *
 * 		<div class="button" ng-click="myClickHandler">Close</div>
 * 		function myClickHandler () {
 * 			$ngModal.openModal("modal-1");
 * 		}
 *
 * @param  {[type]} $ngModal
 * @return {[type]}
 */
.directive("openModal", function ($ngModal) {
	return {
		restrict: "A",
		scope: {
			openModal: "&openModal"
		},
		link: function (scope, elem, attrs) {

			elem.on("click", function () {
				scope.$apply(function () {
					var id = attrs.openModal;
					$ngModal.openModal(id);
				});
			});
		}
	}
})

.factory("$ngModal", function ($rootScope) {

	var factory = {},
		list = [];

	factory.addShownModal = function(name) {
		if(list.indexOf(name) == -1){
			list.push(name);
		}
	}

	factory.removeShownModal = function(name) {
		var find = list.indexOf(name);
		if(find !== -1){
			list.remove(find);
		}
	}

	factory.getOpenList = function() {
		return list;
	}

	factory.getLastOpenModal = function() {
		if(list.length > 0){
			return list[list.length - 1];
		}

		return;
	}

	factory.openModal = function (id) {
		$rootScope.$broadcast("OPEN_MODAL_" + id);
	};

	factory.closeModal = function (id) {
		$rootScope.$broadcast("CLOSE_MODAL_" + id);
	};

	return factory;

});


